import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loginUser, logoutUser, joinConf} from "../../actions/authActions";
import $ from 'jquery';
import moment from 'moment';
import Util from "../../streaming/Util";
import axios from "axios";
import classnames from "classnames";
import Const from "../../constants/Constants";
import { loadElectron } from '../../utils/agora-electron';
import SupportContainer from '../home/SupportContainer';
import SessionDataStore from "../../streaming/SessionDataStoreController";
import Language from '../../services/contentData';
import recordingSession from "../../utils/recordingSession";

class Home extends Component {

  constructor(props){

    super(props);
		this.state = {
			supportPageName: 'Home',
			supportPageApi: '/home',
			userTypeFaqs: 1,
			recordingsFound: false,
			recordingsList: []
		}

    this.checkTime = null;
    this.checkTimeOne = null;
		this.recordSession = new recordingSession();

    var localstoragedata = JSON.parse(localStorage.getItem('userData'));

    if ( localstoragedata.sessionData && !Array.isArray(localstoragedata.sessionData) )
    {
        let sessionEndTime = new Date(new Date(localstoragedata.sessionData.scheduleDate).getTime() + (localstoragedata.sessionData.duration * 60000));

        this.checkTimeOne = setInterval( () => {
            var timeLeft = Math.ceil(Math.round( (new Date(sessionEndTime).getTime() - new Date().getTime()) / 1000 ) / 60 );
            console.log('timeLeft one - ', timeLeft);

            if ( timeLeft <= 0 )
            {
                clearInterval(this.checkTimeOne);

                const userData = {
                    userId: localstoragedata.id,
                    auth: localstoragedata.token
                };

                this.props.loginUser(userData);
            }
        }, 10000);
    }

    this.sessionDataStore = SessionDataStore.getInstance();
  }

  componentDidMount() {

	  var mainThis = this;
	  if ( window['electron'] && JSON.parse(localStorage.getItem('userData')).userType === 1 )
			{
				this.recordSession.checkOldRecordings(function (foundFiles)
				{
					if ( foundFiles )
						{
							console.log('Inside files', foundFiles);
							
							for ( var i = 0; i < foundFiles.length; i++ )
								{
									if ( foundFiles[i].hostId !== JSON.parse(localStorage.getItem('userData')).id ) 
										{
											foundFiles.splice(i, 1);
										}
								}
								
							if ( foundFiles.length > 0 )
								{
									mainThis.setState({'recordingsFound': true, 'recordingsList': foundFiles});
								}
							else
								{
									mainThis.setState({'recordingsFound': false, 'recordingsList': []});
								}
						}
				});
			}
	  
	  
	  
	  // When home is accessed ( after rejoin or stopping class turn off saver lock
	  if ( window['electron'] && window['electronPowerSaver'] && window['electronPowerSaver'].stop )
			{
				if ( window['electronPowerSaverId'] ) { window['electronPowerSaver'].stop(window['electronPowerSaverId']); }
			}
	  
      loadElectron();
      this.checkStartTime();
  }

  onLogoutClick = e => {
    e.preventDefault();
    clearInterval(this.checkTime);
    clearInterval(this.checkTimeOne);
    localStorage.removeItem('deeplinkRef');
	//localStorage.removeItem('settingsInSession');
    this.props.logoutUser();
  };

  checkStartTime = () => {      

      var localstoragedata = JSON.parse(localStorage.getItem('userData'));
      let joinDuration = localstoragedata.default.streamJoiningDefaultTime * 60000;

      if ( localstoragedata.sessionData && Array.isArray(localstoragedata.sessionData) && localstoragedata.showNextPast != 'past' )
      {
          this.checkTime = setInterval( () => {
              localstoragedata.sessionData.forEach( (session) => {
                  var startDateTime = new Date(new Date(session.scheduleDate).getTime() - joinDuration);

                  var timeLeft = Math.ceil(Math.round( (new Date(startDateTime).getTime() - new Date().getTime()) / 1000 ) / 60 );
                  console.log('timeLeft - ', timeLeft);
                  if ( timeLeft <= 0 )
                  {
                      $('#viewchannel-'+session.id).remove();
                      $('#join-'+session.id).removeClass('d-none');
                  }
              });
          }, 10000);
      }
  }

  fetchSessionDetails = (sessionId) => {
    
    let userData = JSON.parse(localStorage.getItem('userData'));
    let token = userData.token;
	let hasRecordingStatus = 0;
	if ( userData.sessionData.hasRecording )
		{
			hasRecordingStatus = userData.sessionData.hasRecording;
		}
	
    let addObject = {"sessionId": sessionId,  "userId": userData.id, "event": "status", "eventType": "joinSession", "details": JSON.stringify({"msg": "Join Class button clicked on Class listing page"}), "timestamp": Util.getCurrentTimestamp()};
    this.sessionDataStore.addSessionData(addObject);

    $('.main_loader').attr({'style':'display:flex'});

    axios.defaults.headers.common['Authorization'] = token;              
    axios.get(process.env.REACT_APP_API_URL+"/api/v1/session/"+sessionId+"/individualsessiondetail")          
      .then(res => {
        clearInterval(this.checkTime);
        clearInterval(this.checkTimeOne);
        $('.main_loader').hide();
        
        let sessionDetail = JSON.stringify(res.data.responseData);

        let sessionDetail1 = JSON.parse(sessionDetail);
		sessionDetail1['sessionData']['hasRecording'] = hasRecordingStatus;
        sessionDetail1.token = token;
        sessionDetail1.unmuteAllEnabled = false;
		let settingsInSession = JSON.parse( localStorage.getItem('settingsInSession'));
		if ( settingsInSession )
			{
				sessionDetail1['sessionData']['StartRecordSession'] = settingsInSession['StartRecordSession'];
				sessionDetail1['sessionData']['StartMusicSession'] = settingsInSession['StartMusicSession'];
				sessionDetail1['sessionData']['showOtherParticipants'] = settingsInSession['showOtherParticipants'];
				sessionDetail1['sessionData']['CustomResolutionHigh'] = settingsInSession['CustomResolutionHigh'];
				sessionDetail1['sessionData']['switchHostParticipant'] = settingsInSession['switchHostParticipant'];
				sessionDetail1['sessionData']['disableNotificationSound'] = settingsInSession['disableNotificationSound'];
				sessionDetail1['sessionData']['calculateAssessmentDimensions'] = settingsInSession['calculateAssessmentDimensions'];
				sessionDetail1['sessionData']['turnoffRoomSetup'] = settingsInSession['turnoffRoomSetup'];
			}

        localStorage.setItem("userData", JSON.stringify(sessionDetail1));

        this.props.history.push("/pre-screen");
      }).catch( err => {
          $('.main_loader').hide();
          console.log('Error in fetching class details - ', err);
          let addObject = {"sessionId": sessionId,  "userId": userData.id, "event": "error", "eventType": "joinSession", "details": JSON.stringify({"msg": "Error in getting class details on Class listing page", "err": err}), "timestamp": Util.getCurrentTimestamp()};
    			this.sessionDataStore.addSessionData(addObject);
      });
  }

  redirect = () => {
      clearInterval(this.checkTime);
      clearInterval(this.checkTimeOne);
      this.props.history.push("/pre-screen");
  }

  closeWindow = () => {
      window.close();
  }
  
  openDemand = () => {
	  var storage = JSON.parse(localStorage.getItem('userData'));
	  storage.sessionData = JSON.parse(JSON.stringify(storage.onDemandData));
	  localStorage.setItem("userData", JSON.stringify(storage));
	  console.log('ondemand1');
	  this.props.history.push("/pre-screen");
  }
  
  deleteRecording = (recItem) => {
	
	if ( window['electron'] && window['fsFile'] )
		{
			$('.main_loader').attr({'style':'display:flex'});
			
			var mainThis = this;
			mainThis.recordSession.deleteOldRecordings(recItem);
			mainThis.reloadRecording();
		}
	  
  }
  
  
  
  pushRecording = (recItem) => {
		
		var $ = window.$ || {};
		var mainThis = this;
		mainThis.recordSession.applyNewRecording(recItem);
		
		mainThis.recordSession.uploadFileToS3(recItem['id'], function (passData)
			{
				if ( !passData )
					{
						mainThis.recordSession.hasRecordingFiles = false;
						mainThis.recordSession.isRecordingNow = false;
						
						console.log('all done');
						$('#session-saving-recording').modal('hide');
						$('#finished-upload-failed').modal('show');
						mainThis.reloadRecording();
						setTimeout(function () { $('.modal').modal('hide'); }, 2000);
					}
				else
					{
						mainThis.recordSession.saveFileForEC2(passData, function ()
							{
								console.log('all done');
								$('#session-saving-recording').modal('hide');
								$('#finished-upload').modal('show');
								mainThis.reloadRecording();
								setTimeout(function () { $('.modal').modal('hide'); }, 2000);
							});
					}
			});
	}
	
  reloadRecording = () => {
			
	var mainThis = this;
	setTimeout(function ()
		{
			mainThis.recordSession.checkOldRecordings(function (foundFiles)
				{
					$('.main_loader').hide();
					if ( foundFiles )
						{
							console.log('Inside files', foundFiles);
							
							for ( var i = 0; i < foundFiles.length; i++ )
								{
									if ( foundFiles[i].hostId !== JSON.parse(localStorage.getItem('userData')).id ) 
										{
											foundFiles.splice(i, 1);
										}
								}
								
							if ( foundFiles.length > 0 )
								{
									mainThis.setState({'recordingsFound': true, 'recordingsList': foundFiles});
								}
							else
								{
									mainThis.setState({'recordingsFound': false, 'recordingsList': []});
								}
						}
						else
						{
							mainThis.setState({'recordingsFound': false, 'recordingsList': []});
						}
				});
		}, 2000);
  }
  
	getOnDemandDuration=(time)=>{
	
		let minutes = 0;
		let hours = 0;
		
		if ( time > 59 )
			{
				minutes = Math.floor(time / 60);
				time = time - (minutes * 60);
			}
		
		if ( minutes > 59 )
			{
				hours = Math.floor(minutes / 60);
				minutes = minutes - (hours * 60);
			}
		
		if ( time < 10 )
			{
				time = '0'+time;
			}
		
		if ( minutes < 10 )
			{
				minutes = '0'+minutes;
			}
		
		if ( hours > 0 )
			{
				return hours + ":" + minutes + ":" + time;
			}
		else 
			{
				return minutes + ":" + time;
			}		
	}
	
  
  
  

render() {

  const {user} = this.props.auth;
 
  var localstoragedata = JSON.parse(localStorage.getItem('userData'));

  let sessionMsg = '';
  let sessionHeading = '';

  if (localstoragedata.showNextPast == 'join') {
      sessionHeading = 'Classes';
      sessionMsg = 'You have an Ongoing Class, click on JOIN CLASS to attend the class';
  } else if (localstoragedata.showNextPast == 'overlap') {
      sessionHeading = 'Classes';
      sessionMsg = 'You have 2 Overlapping Classes, click on JOIN CLASS next to the class you wish to attend';
  } else if (localstoragedata.showNextPast == 'next') {
      sessionHeading = 'Upcoming Classes';
      sessionMsg = 'Hi, you have no Upcoming Classes starting within ' + localstoragedata.default.streamJoiningDefaultTime + ' minutes. Here are your ' + localstoragedata.sessionData.length + ' Upcoming Classes';
  } else if (localstoragedata.showNextPast == 'past') {
      sessionHeading = 'Past Classes';
      sessionMsg = 'Hi, you have no Upcoming Classes. Here is a list of your ' + localstoragedata.sessionData.length + ' Past Classes';
  }

  let dashboardUrl = '';

  if ( localstoragedata.userType == Const.USER_TYPE.HOST )
  {
      dashboardUrl = process.env.REACT_APP_ADMINURL + '/DashboardLanding#autologin;' + localstoragedata.token + ';' + localstoragedata.id;
  }
  else
  {
      dashboardUrl = process.env.REACT_APP_ADMINURL + '/participant-dashboard#autologin;' + localstoragedata.token + ';' + localstoragedata.id;
  }
  
  if ( window['electron'] ) { dashboardUrl += ';s3'; }

  let channelLogin = '#autologin;' + localstoragedata.token + ';' + localstoragedata.id;
  if ( window['electron'] ) { channelLogin += ';s3'; }


  let channelLinkUrl = '';
  if ( localstoragedata.channelLink != undefined && localstoragedata.channelLink != '' )
  {
      channelLinkUrl = localstoragedata.channelLink;

      if ( window['electron'] ) { channelLinkUrl += ';s3'; }
  }

  return (
    <div>
      <header className="header mt-0 position-fixed">
          <div className="row">
            <div className="col-12 col-md-12 d-flex justify-content-between align-items-center add_padr_24">
              <div className="d-flex pl-2 position-relative zindex">
                <div className="count-box position-relative countdown-logo">
                    <img src="images/v-logo.png" className="logo_icon" />
                </div>
                <div className="ml-3 mt-2">
                 <h3 className="main-heading show-hide-title d-block"><img src="images/user-icon.png" className="logo_icon mr-1" />Welcome {localstoragedata.firstName}</h3>
                </div>
              </div>

              <div className="position-relative zindex">
                  <div>
                    <div className="justify-content-end d-flex align-items-center height-56">
                       <div className="add_point" onClick={this.onLogoutClick.bind(this)}>
							<div className="actPopPart add_margr5" >
								<svg width="19" height="20" viewBox="0 0 19 20" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 20C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H15C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V4H14V2H2V18H14V16H16V19C16 19.2652 15.8946 19.5196 15.7071 19.7071C15.5196 19.8946 15.2652 20 15 20H1ZM14 14V11H7V9H14V6L19 10L14 14Z" />
								</svg>
							</div>
						  <div className="actPopPart" >Logout</div>
                        </div>
                    </div>                   
                  </div>
              </div>
            </div>
          </div>     
      </header>

      <div id="upcoming-session-list" className="ffPopins">
        <div className="d-flex justify-content-center align-items-start valign-wrapper1">
          <div className="session-list bg-grayy radius-10 px-5 py-5">
              {/*<p className="text-white font-20">Hi {localstoragedata.firstName},</p>
              <p className="text-white font-20">You do not have any classes scheduled at this moment. Please check your upcoming class start time and log in {localstoragedata.default.streamJoiningDefaultTime} minutes prior to the start of the class.</p>
              <div className="ok_btn_cont w-100 text-center">
              <button className="ok-btn" onClick={this.onLogoutClick}>OK</button>
              </div>*/}
            <hr/>

              {( localstoragedata.sessionData && localstoragedata.sessionData.length > 0 ) && 

                  <div>
                    <div className="session-heading">{sessionHeading}</div>
                    <div className="session-heading-desc">
                      {sessionMsg}
                    </div>
					
					{ ( localstoragedata.onDemandData && localstoragedata.onDemandData.ondemandId ) && 
						<table className="table"> 
							<thead>
								<tr>
									<th scope="col" className="text-left">On Demand Name</th>
									<th scope="col">Instructor Name</th>
									<th scope="col">Date & Time</th>
									<th scope="col">Duration</th>
									<th scope="col">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr>
								  <td>{localstoragedata.onDemandData.name}</td>
								  <td>{localstoragedata.onDemandData.hostFirstName}</td>
								  <td>{moment(localstoragedata.onDemandData.onDemandTime).format('MMM DD, YYYY @ h:mm A')}</td>
								  <td>{this.getOnDemandDuration(localstoragedata.onDemandData.od_duration)}</td>
								  <td>
									  <button type="button" className="btn-channel btn btn-large btn-primary text-uppercase py-1 px-4 rounded nBack" onClick={this.openDemand}>PROCEED</button>
								  </td>
								</tr>
							</tbody>
						</table>
					}
					
					<table className="table">
                        <thead>
                          <tr>
                            <th scope="col" className="text-left">Class Name</th>
                            <th scope="col">Instructor Name</th>
                            <th scope="col">Date & Time</th>
                            <th scope="col">Duration</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            localstoragedata.sessionData.map((opt, i) =>
                              <tr key={i}>
                                <td>{opt.name}</td>
                                <td>{opt.hostFirstName}</td>
                                <td>{moment(opt.scheduleDate).format('MMM DD, YYYY @ h:mm A')}</td>
                                <td>{Util.getDuration(opt.duration)}</td>
                                <td id={opt.id}>
                                    {( opt.channelLink != undefined && opt.channelLink != '' && Util.showChannelLink(localstoragedata, i) ) && 
                                        <a href={opt.channelLink + channelLogin} target={ window['electron'] ? '_blank' : '_self' }>
                                          <button type="button" id={'viewchannel-' + opt.id} className="btn-channel btn btn-large btn-primary py-1 px-4 rounded nBack">View Channel</button>
                                        </a>
                                    }

                                    <button type="button" id={'join-' + opt.id} className={ classnames({ 'btn-channel btn btn-large btn-primary py-1 px-4 rounded nBack': true, 'd-none': Util.showJoinButton(localstoragedata, i) ? false : true }) } onClick={this.fetchSessionDetails.bind(this, opt.id)}>JOIN CLASS</button>
                                </td>
                              </tr>
                            )}
                        </tbody>
                    </table>
                  </div>
              }

              {( localstoragedata.sessionData && !Array.isArray(localstoragedata.sessionData) ) && 

                  <div>
                    <div className="session-heading">Ongoing Class</div>
                    <div className="session-heading-desc">
                        <span>You have an Ongoing Class, click on JOIN CLASS to attend the class</span>                 
                    </div>
					
					{ ( localstoragedata.onDemandData && localstoragedata.onDemandData.ondemandId ) && 
						<table className="table"> 
							<thead>
								<tr>
									<th scope="col" className="text-left">On Demand Name</th>
									<th scope="col">Instructor Name</th>
									<th scope="col">Date & Time</th>
									<th scope="col">Duration</th>
									<th scope="col">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr>
								  <td>{localstoragedata.onDemandData.name}</td>
								  <td>{localstoragedata.onDemandData.hostFirstName}</td>
								  <td>{moment(localstoragedata.onDemandData.onDemandTime).format('MMM DD, YYYY @ h:mm A')}</td>
								  <td>{this.getOnDemandDuration(localstoragedata.onDemandData.od_duration)} min</td>
								  <td>
									  <button type="button" className="btn-channel btn btn-large btn-primary text-uppercase py-1 px-4 rounded nBack" onClick={this.openDemand}>PROCEED</button>
								  </td>
								</tr>
							</tbody>
						</table>
					}
                    
                    <table className="table">
                        <thead>
                          <tr>
                            <th scope="col" className="text-left">Class Name</th>
                            <th scope="col">Instructor Name</th>
                            <th scope="col">Date & Time</th>
                            <th scope="col">Duration</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr>
                              <td>{localstoragedata.sessionData.name}</td>
                              <td>{localstoragedata.sessionData.hostFirstName}</td>
                              <td>{moment(localstoragedata.sessionData.scheduleDate).format('MMM DD, YYYY @ h:mm A')}</td>
                              <td>{Util.getDuration(localstoragedata.sessionData.duration)}</td>
                              <td>
                                  <button type="button" className="btn-channel btn btn-large btn-primary text-uppercase py-1 px-4 rounded nBack" onClick={this.fetchSessionDetails.bind(this, localstoragedata.sessionData.id)}>JOIN CLASS</button>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
              }
            
              {( localstoragedata.showNextPast == 'none' ) && 
                  <div style={{ color: "#ffffff", padding: "10px", fontSize: "20px" }}>
                    <p className="text-center">Hi, you have not signed up for a Class on Virdio yet, please click below if you would like to be taken to your Dashboard.</p>
                  </div>
              }

              {/*{( localstoragedata.sessionData == undefined ) && 
                  <div style={{ color: "#ffffff", padding: "10px", fontSize: "20px" }}>
                    <p className="text-center">There is no any Upcoming or Past Class.</p>
                    <p className="text-center">We recommend you go to Dashboard or visit Channel Page.</p>
                  </div>
              }*/}

              <div className="session-list-footer">

                {( localStorage.getItem('deeplinkRef') == null && ( localstoragedata.showNextPast == 'next' || localstoragedata.showNextPast == 'past' || localstoragedata.showNextPast == 'none' ) ) && 
                    <a href={dashboardUrl} target={ window['electron'] ? '_blank' : '_self' }>
                      <button type="button" className="btn-join btn btn-large btn-primary py-1 px-4 rounded nBack">DASHBOARD</button>
                    </a>
                }

                {( localStorage.getItem('deeplinkRef') !== null && ( localstoragedata.showNextPast == 'next' || localstoragedata.showNextPast == 'past' ) ) && 
                    <button type="button" className="btn-join btn btn-large btn-primary py-1 px-4 rounded nBack" onClick={this.closeWindow.bind(this)}>CLOSE</button>
                }

                {( localstoragedata.sessionData == undefined && localstoragedata.channelLink != undefined && localstoragedata.channelLink != '' && localStorage.getItem('deeplinkRef') == null ) && 
                    <a href={channelLinkUrl} className="ml-3" target={ window['electron'] ? '_blank' : '_self' }>
                      <button type="button" className="btn-join btn btn-large btn-primary py-1 px-4 rounded nBack">VIEW CHANNEL</button>
                    </a>
                }
              </div>
			  
			  { this.state.recordingsFound == true &&
				<div>
					<br />
					<hr/>
					<div className="msg_container">
						<div className="recording_msg">Oops! On-Demand Class recording upload failed.
							<div className="alert_icon"></div>
						</div>           
					</div>
					
					<table className="table">
						<thead>
							<tr>
								<th scope="col" className="text-left">Class Name</th>
								<th scope="col">Date & Time</th>
								<th scope="col">Action</th>
							</tr>
						</thead>
						<tbody>
							  { this.state.recordingsList.map((opt, i) =>
								  <tr key={i}>
									<td>{opt.name}</td>
									<td>{moment(opt.scheduleDate).format('MMM DD, YYYY @ h:mm A')}</td>
									<td id={opt.id}>
										<button type="button" className="btn-channel btn btn-large btn-primary py-1 px-4 rounded recbtns nBack" onClick={() => this.pushRecording(opt)}>UPLOAD RECORDING</button>
										&nbsp;&nbsp;
										<button type="button" className="btn-channel btn btn-large btn-primary py-1 px-4 rounded recbtns nBack" onClick={() => this.deleteRecording(opt)}>DELETE RECORDING</button>
									</td>
								  </tr>
								)}
						</tbody>
					</table>
				</div>
				}
			  
			  
          </div>
        </div>
      </div>
	  
	  
	  <div id="session-saving-recording" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
			<div className="modal-dialog modal-confirm modal-dialog-centered">
				<div className="modal-content bg-grayy px-4 position-relative radius-10">
					<div className="modal-header justify-content-center px-0 border-bottm">
						<h5 className="modal-title white_hdng">{Language.recordingPopUp.heading}</h5>
					</div>
					<div className="modal-body">
						<div>
							<p className="text-white font-20 mb-4">{Language.recordingPopUp.bodyMsg}</p>
							<div className="newprogressbar"><div></div></div>
							<div className="text-white newprogressbarinfo"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
  
		<div id="finished-upload" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
		  <div className="modal-dialog modal-confirm modal-dialog-centered">
			<div className="modal-content bg-grayy px-4 position-relative radius-10">
			  <div className="modal-body">
				<div>
				  <p className="text-white font-20 mb-4 recording_alert_hold">Recording uploaded successfully.</p>
				</div>
			  </div>
			</div>
		  </div>
		</div>
		
		 <div id="finished-upload-failed" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
		  <div className="modal-dialog modal-confirm modal-dialog-centered">
			<div className="modal-content bg-grayy px-4 position-relative radius-10">
			  <div className="modal-body">
				<div>
				  <p className="text-white font-20 mb-4 recording_alert_hold">Recording not uploaded.</p>
				</div>
			  </div>
			</div>
		  </div>
		</div>
		
		  <div id="retry-upload" className="modal fade bg-transparent" data-backdrop="static" data-keyboard="false">
			<div className="modal-dialog modal-confirm modal-dialog-centered">
			  <div className="modal-content bg-grayy px-4 position-relative radius-10">
				<div className="modal-body">
				  <div>
					<p className="text-white font-20 mb-4 recording_alert_hold">There is a problem with uploading recording. Please make sure you have stable internet connection and try again.</p>
				  </div>
				</div>
				<div className="ok_btn_cont">
				  <button className="ok-btn" onClick={ () => window.retryUploadRec() }>RETRY</button>
				  <button className="ok-btn" onClick={ () => window.stopUploadRec() }>CANCEL</button>
				</div>
			  </div>
			</div>
		  </div>
	  
      <div className="main_loader">
        <div className="main_loader_inner"></div>
      </div>
	  
	  <SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
      </div>
    );
  }
}
Home.propTypes = {
  loginUser: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
  joinConf: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(
  mapStateToProps,
  { loginUser, logoutUser, joinConf }
)(Home);